import { defineMessages } from 'react-intl';

export default defineMessages({
    legalText: {
        id: '_.rblOffer_configuration.legal_text',
        defaultMessage:
            'Repayments are automatically collected by eBay and we estimate it will take <fetching><bold>{period} months</bold></fetching> to repay the loan. The actual duration will depend upon revenue. Half of the expected repayment is due as a minimum repayment every 60 days. If the minimum repayment is not met, we will collect the difference by direct debit.'
    }
});
